import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Marquee from '../components/Marquee';
import Services from '../components/Services';
import Transform from '../components/Transform';
import PortfolioVideos from '../components/PortfolioVideos';
import PortfolioPosts from '../components/PortfolioPosts';
import ParaQuem from '../components/ParaQuem';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[color:var(--brown-700)] text-[color:var(--text-light)] grain">
      <Navbar />
      <Hero />
      <About />
      <Marquee />
      <Services />
      <Transform />
      <PortfolioVideos />
      <PortfolioPosts />
      <ParaQuem />
      <Testimonials />
      <CTA />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
